import { useTranslation } from "react-i18next";

import { Button } from "../shared/Button";
import { Markdown } from "../shared/Markdown";

import "./AssistancePush.scss";

const classNamePrefix = "AssistancePush";

export const AssistancePush = () => {
  const { t } = useTranslation();
  const { action, text } = t(
    "features.assistance.AssistancePush",
  ) as unknown as { action: { text: string }; text: string };

  const handleFaqClick = () => {
    const faqUrl = `${window.location.origin}/#faq`;
    window.open(faqUrl, "_blank");
  };

  return (
    <div className={classNamePrefix}>
      <div className={`${classNamePrefix}-action`}>
        <Button
          onClick={handleFaqClick}
          dataLayer={{
            eventAction: "clic",
            eventCategory: "pre-home",
            eventLabel: "lien-faq-nfr",
          }}
        >
          {action.text}
        </Button>
      </div>
      <div className={`${classNamePrefix}-text`}>
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
};
